import { render, staticRenderFns } from "./Course.vue?vue&type=template&id=74ec3c0c"
import script from "./Course.vue?vue&type=script&lang=js"
export * from "./Course.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports